import React, { useEffect, useRef, useState } from 'react'
import { Navigate, NavLink, useLocation, useNavigate } from 'react-router-dom'
import Category from 'src/svgComponents/sidebarIcons/Category'
import MainCategory from 'src/svgComponents/sidebarIcons/Category'
import Roles from 'src/svgComponents/sidebarIcons/Roles'
import UserCircle from 'src/svgComponents/sidebarIcons/UesrCircle'
import RolesPermissions from 'src/svgComponents/sidebarIcons/Roles'
import Dashboard from 'src/svgComponents/sidebarIcons/Dashboard'
import SubAdmin from 'src/svgComponents/sidebarIcons/SubAdmin'
import Vender from 'src/svgComponents/sidebarIcons/Business'
import EventIcon from 'src/svgComponents/sidebarIcons/Trust'
import FoodIcon from 'src/svgComponents/sidebarIcons/Category'
import GroceryIcon from 'src/svgComponents/sidebarIcons/Category'
import SupportIcon from 'src/svgComponents/sidebarIcons/Configurable'
import PayoutIcon from 'src/svgComponents/sidebarIcons/Configurable'
import NotificationIcon from 'src/svgComponents/sidebarIcons/Trust'
import SettingIcon from 'src/svgComponents/sidebarIcons/Setting'
import { PATH_DASHBOARD } from 'src/routes/paths'
import { Box, Button, Card, Divider, IconButton, InputBase, List, Paper, Stack, ListItem, Collapse } from '@mui/material'
import useStore from 'src/contexts/AuthProvider'
import MapFeedItem from '../home/MapFeedItem'
import GroceryCategory from "src/svgComponents/HomeIcon"
import ListSubheader from '@mui/material/ListSubheader';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
// import Collapse from '@mui/material/Collapse';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import DraftsIcon from '@mui/icons-material/Drafts';
import SendIcon from '@mui/icons-material/Send';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import StarBorder from '@mui/icons-material/StarBorder';
import Dropdown from './Dropdown'
// import { K } from 'chart.js/dist/chunks/helpers.core'
// import EventIcon from '@mui/icons-material/Event';

let submenuList = [
    {
        linkText: 'Vendor List',
        link: PATH_DASHBOARD.general.approved_vendor,
        linkIconElem: "",
        permission: "VendorList",//11101
        status: 2
    },
    // {
    //     linkText: 'Pending vendors',
    //     link: PATH_DASHBOARD.general.pending_vendor,
    //     linkIconElem: "",
    //     permission: "PendingVendors",
    //     status: 2
    // },

    // {
    //     linkText: 'Rejected vendors',
    //     link: PATH_DASHBOARD.general.rejected_vendor,
    //     linkIconElem: "",
    //     permission: "RejectedVendors",
    //     status: 2
    // },
    // {
    //     linkText: 'Pending KYC',
    //     link: PATH_DASHBOARD.general.pending_kyc_vendor,
    //     linkIconElem: "",
    //     permission: "PendingKYC",
    //     status: 2
    // },
    {
        linkText: 'Pending Bank',
        link: PATH_DASHBOARD.general.pending_bank_vendor,
        linkIconElem: "",
        permission: "PendingBank",
        status: 2
    },
    {
        linkText: 'Change Bank',
        link: PATH_DASHBOARD.general.changeBankVendor,
        linkIconElem: "",
        permission: "ChangeBank",
        status: 2
    },
]
let kycmenuList = [
    {
        linkText: 'Approved KYC',
        link: PATH_DASHBOARD.general.approvedKYC,
        linkIconElem: "",
        permission: "ApprovedKYC",
        status: 2
    },
    {
        linkText: 'Pending KYC',
        link: PATH_DASHBOARD.general.pendingKYC,
        linkIconElem: "",
        permission: "PendingKYC",//11101
        status: 2
    },
    // {
    //     linkText: 'Not Approved KYC',
    //     link: PATH_DASHBOARD.general.rejected_vendor,
    //     linkIconElem: "",
    //     permission: "NotApprovedKYC",
    //     status: 2
    // },
    {
        linkText: 'Not Uploaded KYC',
        link: PATH_DASHBOARD.general.not_uploaded_kyc,
        linkIconElem: "",
        permission: "NotUploadedKYC",
        status: 2
    },
    // {
    //     linkText: 'Pending Bank',
    //     link: PATH_DASHBOARD.general.pending_bank_vendor,
    //     linkIconElem: "",
    //     permission: "PendingBank",
    //     status: 2
    // },
]
let payoutList = [
    {
        linkText: 'Approved Payout',
        link: PATH_DASHBOARD.general.approvedPayout,
        linkIconElem: "",
        permission: "ApprovedPayout",
        status: 2
    },
    {
        linkText: 'Pending Payout',
        link: PATH_DASHBOARD.general.pendingPayout,
        linkIconElem: "",
        permission: "PendingPayout",
        status: 2
    },
    {
        linkText: 'Transaction List',
        link: PATH_DASHBOARD.general.transactionList,
        linkIconElem: "",
        permission: "TransactionList",
        status: 2
    },
]
let userList = [
    {
        linkText: 'Users List',
        link: PATH_DASHBOARD.general.regUsers,
        linkIconElem: "",
        permission: "Users",
        status: 2
    },
    {
        linkText: 'Request for Delete Account List',
        link: PATH_DASHBOARD.general.deleteRequestUserList,
        linkIconElem: "",
        permission: "DeleteRequestUserList",
        status: 2
    },
    {
        linkText: 'Delete User List',
        link: PATH_DASHBOARD.general.deleteUserList,
        linkIconElem: "",
        permission: "DeleteUserList",
        status: 2
    },
]
let eventSubMenuList = [
    {
        linkText: 'Event List',
        link: PATH_DASHBOARD.general.event_list,
        linkIconElem: "",
        permission: "EventList",
        status: 2
    }, {
        linkText: 'Event Transaction',
        link: PATH_DASHBOARD.general.eventTransactionList,
        linkIconElem: "",
        permission: "EventTransaction",
        status: 2
    },
];
let ngoSubMenuList = [
    {
        linkText: 'NGO Charity Items',
        link: PATH_DASHBOARD.general.ngo_charity_item_list,
        linkIconElem: "",
        permission: "NGoCharityItems",
        status: 2
    },
    {
        linkText: 'Donation Transaction',
        link: PATH_DASHBOARD.general.donationTransactionList,
        linkIconElem: "",
        permission: "DonationTransaction",
        status: 2
    },
]
let foodSubMenuList = [
    {
        linkText: 'Food Order',
        link: PATH_DASHBOARD.general.foodOrder,
        linkIconElem: "",
        permission: "FoodOrder",
        status: 2
    },
    // {
    //     linkText: 'Disputed Order',
    //     link: PATH_DASHBOARD.general.foodDisputedOrder,
    //     linkIconElem: "",
    //     permission: "DisputedFoodOrder",
    //     status: 2
    // },
    {
        linkText: 'Food Dish List',
        link: PATH_DASHBOARD.general.foodDishList,
        linkIconElem: "",
        permission: "FoodDishList",
        status: 2
    },
]
let grocerySubMenuList = [
    {
        linkText: 'Grocery Order',
        link: PATH_DASHBOARD.general.groceryOrder,
        linkIconElem: "",
        permission: "GroceryOrder",
        status: 2
    },
    // {
    //     linkText: 'Disputed Order',
    //     link: PATH_DASHBOARD.general.groceryDisputedOrder,
    //     linkIconElem: "",
    //     permission: "DisputedGroceryOrder",
    //     status: 2
    // },
    {
        linkText: 'Grocery List',
        link: PATH_DASHBOARD.general.groceryList,
        linkIconElem: "",
        permission: "GroceryList",
        status: 2
    },
]
let adminSettingSubMenu = [
    // {
    //     id: 'item14',
    //     linkText: 'Coupon',
    //     link: PATH_DASHBOARD.general.coupon,
    //     linkIconElem: "",
    //     permission: "Coupon",
    //     status: 2
    // },
    {
        linkText: 'Admin Fees',
        link: PATH_DASHBOARD.general.adminfees,
        linkIconElem: "",
        permission: "AdminFees",
        status: 2
    },
    {
        linkText: 'CMS Pages',
        link: PATH_DASHBOARD.general.cmsPages,
        linkIconElem: "",
        permission: "CMSPages",
        status: 2
    },
    {
        id: 'item11',
        linkText: 'Support Subject',
        link: PATH_DASHBOARD.general.supportSubject,
        linkIconElem: "",
        permission: "SupportSubject",
        status: 2
    },
    {
        id: 'item12',
        linkText: 'FAQ',
        link: PATH_DASHBOARD.general.FAQ,
        linkIconElem: "",
        permission: "FAQ",
        status: 2
    },
    {
        id: 'item13',
        linkText: 'Manage MasterPassword',
        link: PATH_DASHBOARD.general.MasterPassword,
        linkIconElem: "",
        permission: "MasterPassword",
        status: 2
    },
]
let settingSubMenuList = [
    {
        id: 'item06',
        linkText: 'Main Category',
        link: PATH_DASHBOARD.general.mainCategory,
        linkIconElem: "",
        permission: "MainCategory",
        status: 2
    },
    {
        id: 'item07',
        linkText: 'Food Sub Categories',
        link: PATH_DASHBOARD.general.foodCategory,
        linkIconElem: "",
        permission: "FoodSubCategories",
        status: 2
    },
    {
        id: 'item08',
        linkText: 'Grocery Sub Categories',
        link: PATH_DASHBOARD.general.groceryCategory,
        linkIconElem: "",
        permission: "GrocerySubCategories",
        status: 2
    },
    {
        id: 'item13',
        linkText: 'App Version',
        link: PATH_DASHBOARD.general.appVersion,
        linkIconElem: "",
        permission: "AppVersion",
        status: 2
    },
    {
        id: 'item10',
        linkText: 'Roles',
        link: PATH_DASHBOARD.general.rolePermission,
        linkIconElem: "",
        permission: "Roles",
        status: 2
    },
    {
        id: 'item09',
        linkText: 'Permission',
        link: PATH_DASHBOARD.general.permission,
        linkIconElem: "",
        permission: "Permission",
        status: 2
    },

]
const sidebarData = [
    {
        id: 'item01',
        linkText: 'Dashboard',
        link: PATH_DASHBOARD.general.dashboard,
        linkIconElem: <Dashboard color={"#fff"} />,
        permission: "",
        subMenu: []
    },
    {
        id: 'item02',
        linkText: 'Sub Admin',
        link: PATH_DASHBOARD.general.authUsers,
        linkIconElem: <SubAdmin color={"#fff"} />,
        permission: "SubAdmin",
        subMenu: []
    },
    {
        id: 'item03',
        linkText: 'Vendor',
        link: PATH_DASHBOARD.general.vendor,
        linkIconElem: <Vender color={"#fff"} />,
        permission: "",
        subMenu: submenuList
    },
    {
        id: 'item03',
        linkText: 'Vendor KYC',
        link: PATH_DASHBOARD.general.vendor,
        linkIconElem: <Vender color={"#fff"} />,
        permission: "",
        subMenu: kycmenuList
    },
    {
        id: 'item04',
        linkText: 'Users',
        link: PATH_DASHBOARD.general.regUsers,
        linkIconElem: <UserCircle color={"#fff"} />,
        permission: "",
        subMenu: userList,
    },
   /*  {
        id: 'item05',
        linkText: 'Payout',
        link: PATH_DASHBOARD.general.approvedPayout,
        linkIconElem: <PayoutIcon color={"#fff"} />,
        permission: "",
        subMenu: payoutList
    }, */
    {
        id: 'item05',
        linkText: 'Payout',
        link: PATH_DASHBOARD.general.approvedPayout,
        linkIconElem: <PayoutIcon color={"#fff"} />,
        permission: "",
        subMenu: payoutList
    },
    {
        id: 'item06',
        linkText: 'Food',
        link: PATH_DASHBOARD.general.foodOrder,
        linkIconElem: <FoodIcon color={"#fff"} />,
        permission: "",
        subMenu: foodSubMenuList
    },
    {
        id: 'item07',
        linkText: 'Grocery',
        link: PATH_DASHBOARD.general.foodOrder,
        linkIconElem: <GroceryIcon color={"#fff"} />,
        permission: "",
        subMenu: grocerySubMenuList
    },
    {
        id: 'item08',
        linkText: 'Event List',
        link: PATH_DASHBOARD.general.event_list,
        linkIconElem: <EventIcon color={"#fff"} />,
        permission: "EventList",
        subMenu: eventSubMenuList
    },
    {
        id: 'item09',
        linkText: 'NGO',
        link: PATH_DASHBOARD.general.ngo_charity_item_list,
        linkIconElem: <Roles color={"#fff"} />,
        permission: "",
        subMenu: ngoSubMenuList
    },
    {
        id: 'item10',
        linkText: 'Setting',
        link: PATH_DASHBOARD.general.coupon,
        linkIconElem: <SettingIcon color={"#fff"} />,
        permission: "Setting",
        subMenu: settingSubMenuList
    },
    {
        id: 'item11',
        linkText: 'Admin Setting',
        link: PATH_DASHBOARD.general.coupon,
        linkIconElem: <SettingIcon color={"#fff"} />,
        permission: "",
        subMenu: adminSettingSubMenu
    },
    {
        id: 'item12',
        linkText: 'Notification',
        link: PATH_DASHBOARD.general.notification,
        linkIconElem: <NotificationIcon color={"#fff"} />,
        permission: "Notification",
        subMenu: []
    },
    {
        id: 'item13',
        linkText: 'Support Ticket',
        link: PATH_DASHBOARD.general.supportTicket,
        linkIconElem: <SupportIcon color={"#fff"} />,
        permission: "SupportTicket",
        subMenu: []
    },
    {
        id: 'item13',
        linkText: 'Advertisement',
        link: PATH_DASHBOARD.general.advertisement,
        linkIconElem: <SupportIcon color={"#fff"} />,
        permission: "Advertisement",
        subMenu: []
    },
    {
        id: 'item14',
        linkText: 'Subscriber List',
        link: PATH_DASHBOARD.general.Subscriber,
        linkIconElem: <SupportIcon color={"#fff"} />,
        permission: "SubscriberList",
        subMenu: []
    },
    {
        id: 'item15',
        linkText: 'Feedback',
        link: PATH_DASHBOARD.general.feedback,
        linkIconElem: <SupportIcon color={"#fff"} />,
        permission: "Feedback",
        subMenu: []
    },
]

const MainSidebar = () => {
    const location = useLocation();
    let activeLink = location.pathname;
    const locationData = useStore(state => state.locationData);
    const permissionsData = useStore(state => state.permissions);
    const sidebarContentBoxRef = useRef(null);
    const [searchValue, setSearchValue] = useState('');
    const [expanded, setExpanded] = React.useState('panel1');

    // Sidebar Menu Functionality
    const handleSubmenuChange = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false);
    };

    useEffect(() => {
        sidebarContentBoxRef?.current?.addEventListener("scroll", () => {
            if (sidebarContentBoxRef.current.scrollTop > 10) {
                sidebarContentBoxRef.current.classList.add("scrolling")
            } else {
                sidebarContentBoxRef.current.classList.remove("scrolling")
            }
        })
    }, [])
    const [open, setOpen] = React.useState(true);
    const handleClick = () => {
        setOpen(!open);
    };

    return (
        <Box className="main_sidebar_wrapper">
            <List>
                {sidebarData.map(({ linkText, link, linkIconElem, permission, subMenu, id }, index) => {
                    {/* if (permission !== "") {
                        return (
                            permissionsData?.[permission]?.substring(0, 1) === "1" ?
                                <SidebarMenuItem key={index} activeLink={activeLink} subMenu={subMenu} link={link} linkIconElem={linkIconElem} linkText={linkText} permissionsData={permissionsData} /> : <></>
                        )
                    }
                    else {
                    } */}
                    return <SidebarMenuItem key={index} activeLink={activeLink} subMenu={subMenu} link={link} linkIconElem={linkIconElem} linkText={linkText} permissionsData={permissionsData} />
                }
                )}
            </List>
        </Box>
    )
}

export default MainSidebar

const SidebarMenuItem = ({ index, activeLink, link, linkIconElem, linkText, subMenu, permissionsData }) => {

    const [openSubMenu, setOpenSubMenu] = useState(false);

    const handleClick = () => {
        setOpenSubMenu(!openSubMenu);
    };

    let navigate = useNavigate();

    let p = subMenu.filter(v => { return permissionsData[v.permission]?.substring(0, 1) === "1" })
    // console.log("p",p)

    return (<>{subMenu.length === 0 ?
        <ListItemButton onClick={() => navigate(link)} key={index} className={`main_sidebar_item ${activeLink === link ? 'isActive' : ''}`}>
            <ListItemIcon sx={{ minWidth: 'unset', width: '30px', color: '#fff' }}>
                {linkIconElem}
            </ListItemIcon>
            <span className='main_sidebar_link_text text_limit_180'>{linkText}</span>
        </ListItemButton>
        :
        <>
            {p.length > 0 ?
                <ListItemButton className={`main_sidebar_item `} onClick={handleClick}>
                    <ListItemIcon sx={{ minWidth: 'unset', width: '30px', color: '#fff' }}>
                        {linkIconElem}
                    </ListItemIcon>
                    <span className='main_sidebar_link_text text_limit_180'>{linkText}</span>
                    {openSubMenu ? <ExpandLess style={{ color: '#fff' }} /> : <ExpandMore style={{ color: '#fff' }} />}
                </ListItemButton>
                : ""}
            <Collapse in={openSubMenu} timeout="auto" unmountOnExit>
                <List component="div" disablePadding sx={{ display: 'flex', flexDirection: 'column', py: 1 }}>
                    {subMenu.map((item, index) => {
                        if (item.permission !== '') {
                            return permissionsData?.[item.permission]?.substring(0, 1) === "1" ? <ListItemButton onClick={() => navigate(item.link)} className={`main_sidebar_item sublink ${activeLink === item.link ? 'isActive' : ''}`} key={index} sx={{ pl: 4, py: 1 }}>
                                <ListItemIcon sx={{ minWidth: 'unset', width: '30px', color: '#fff' }}>
                                    {item.linkIconElem}
                                </ListItemIcon>
                                <span className='main_sidebar_link_text text_limit_180'>{item.linkText}</span>
                            </ListItemButton> : <></>
                        } else {
                            return <ListItemButton onClick={() => navigate(item.link)} className={`main_sidebar_item sublink ${activeLink === item.link ? 'isActive' : ''}`} key={index} sx={{ pl: 4, py: 1 }}>
                                <ListItemIcon sx={{ minWidth: 'unset', width: '30px', color: '#fff' }}>
                                    {item.linkIconElem}
                                </ListItemIcon>
                                <span className='main_sidebar_link_text text_limit_180'>{item.linkText}</span>
                            </ListItemButton>
                        }
                    })}
                </List>
            </Collapse>
        </>
    }
    </>)
}

